import { TPAComponentProps } from '../../types';

export interface IconToggleOnChangeEvent
  extends React.ChangeEvent<HTMLInputElement> {
  checked: boolean;
}

export enum IconToggleLabelPlacement {
  START = 'start',
  END = 'end',
}

export interface IconToggleProps extends TPAComponentProps {
  icon: React.ReactNode;
  checkedIcon?: React.ReactNode;
  label?: React.ReactNode;
  labelPlacement?: IconToggleLabelPlacement;
  onChange?(event: IconToggleOnChangeEvent): void;
  checked?: boolean;
  disabled?: boolean;
  animation?: boolean;
  'aria-label'?: string;
  'aria-labelledby'?: string;
}
